var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPersonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#ffffff",
    width: 512,
    height: 512,
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M360.9 452.6c-155.8-116.8-127.8-293.6-43-378C418.4-25.6 577.7-24.9 675.3 77c86.2 90 103.4 260.5-42.3 373.9 74 30 132.6 78.2 178.7 140.8C897 707.8 926.5 839.4 917.3 981.6c-1.3 20-13.1 18.1-26.1 18.1-152.4-.1-304.9-.1-457.3-.1-109.3 0-218.6-.3-327.8.3-15.7.1-23.2-3.2-24.2-20.2-10.9-189.6 43.7-352.8 193.4-477 25.3-21 54.9-36 85.6-50.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonIcon);
export default __webpack_public_path__ + "static/media/personIcon.8ddfae943a491b6c7ae5fd96641565ff.svg";
export { ForwardRef as ReactComponent };